import { useState } from 'react';

export function useContractImport() {
  const [importTargetPartyId, setImportTargetPartyId] = useState(null);
  const [importTargetPartnerIndex, setImportTargetPartnerIndex] = useState(0);

  return {
    importTargetPartyId, setImportTargetPartyId,
    importTargetPartnerIndex, setImportTargetPartnerIndex,
  };
}
